"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service pro práci s typy dokumentu. Generated from cz.marbes.api.dokument.v1.TypDokumentService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:58:29Z                      #

// ##############################################################

var TypDokumentApi = function () {
  function TypDokumentApi() {
    (0, _classCallCheck3.default)(this, TypDokumentApi);
  }

  (0, _createClass3.default)(TypDokumentApi, null, [{
    key: "updateTypDokument",

    /**
     * Aktualizace existujícího typu dokumentu.
     *
     * @param typDokumentKod kód typu dokumentu
     * @param typDokument 
     * @return aktualizovaný typ dokument
     */
    value: function updateTypDokument(typDokumentKod, typDokument) {
      var uri = serverContextPath + ("/typy/dokumentu/" + typDokumentKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.put(uri, params, UpdateMethods.updateTypDokument_8E5AECv1(typDokument), headers));
    }

    /**
     * Vrací kolekci šablon navázaných na typ dokumentu.
     *
     * @param kodTypDokument 
     * @return šablony navázané na typ dokumentu
     */

  }, {
    key: "getSablonyProTypDokumentu",
    value: function getSablonyProTypDokumentu(kodTypDokument) {
      var uri = serverContextPath + "/typy/dokumentu/sablony";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Smaže typ dokumentu s daným kódem.
     *
     * @param typDokumentKod kód typu dokumentu
     */

  }, {
    key: "deleteTypDokument",
    value: function deleteTypDokument(typDokumentKod) {
      var uri = serverContextPath + ("/typy/dokumentu/" + typDokumentKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.delete(uri, params));
    }

    /**
     * Dohledání typů dokumentu dle seznamu předaných kódů.
     *
     * @param kodTypDokuments seznam kódů typu dokumentu
     * @return seznam dohledaných typů dokumentu
     */

  }, {
    key: "getTypyDokumentu",
    value: function getTypyDokumentu(kodTypDokuments) {
      var uri = serverContextPath + "/typy/dokumentu/batchRequest";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, kodTypDokuments, headers));
    }

    /**
     * Vrací typ dokumentu s předanýcm kódem.
     *
     * @param kodTypDokument kód typu dokumentu
     * @return {@link TypDokument}
     */

  }, {
    key: "getTypDokumentByKod",
    value: function getTypDokumentByKod(kodTypDokument) {
      var uri = serverContextPath + "/typy/dokumentu/";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Konfigurace typu dokumentu. Pokud neexistuje typ dokumentu s předaným kódem, založí ho. Pokud typ dokumentu existuje, vrací uložený záznam.
     *
     * @param kodTypDokument 
     * @param nazevDokument 
     * @return založeny typ dokumentu
     */

  }, {
    key: "createTypDokument",
    value: function createTypDokument(kodTypDokument, nazevDokument) {
      var uri = serverContextPath + "/typy/dokumentu/create";
      var headers = undefined;
      var params = { kodTypDokument: kodTypDokument, nazevDokument: nazevDokument };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Vrací všechny typy dokumentů seřazené dle {@link TypDokument#getNazev()}.
     *
     * @return typy dokumentů
     */

  }, {
    key: "findTypyDokumentu",
    value: function findTypyDokumentu() {
      var uri = serverContextPath + "/typy/dokumentu/";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }
  }]);
  return TypDokumentApi;
}();

exports.default = TypDokumentApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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